import React, { ReactNode } from 'react';
import { Menu, Divider } from 'antd';
import { MenuProps as AntdMenuProps } from 'antd/es/menu';
import './index.less';

export interface MenuItemProps {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  clstag?: string;
  hidden?: boolean;
  dividerNode?: ReactNode;
  isDivider?: boolean;
  active?: boolean;
}

export interface CustomMenuProps extends Omit<AntdMenuProps, 'items'> {
  items?: MenuItemProps[];
  className?: string;
  itemClassName?: string;
  showIcon?: boolean;
  iconPosition?: 'left' | 'right';
  onClickMenu?: Function;
  styleObj?: any;
}

export default function CustomMenu(props: CustomMenuProps): any {  
  const {
    items = [],
    className = '',
    itemClassName = '',
    showIcon = true,
    iconPosition = 'left',
    onClickMenu,
    styleObj,
    ...restProps
  } = props;  
  const renderMenuItem = (item: MenuItemProps) => {
    const { key, label, icon, disabled, onClick, clstag, hidden, dividerNode, isDivider, active } = item;
    if(hidden) return null;
    if(isDivider){
      return dividerNode || <Divider style={{margin: "0px", height: "1px", backgroundColor: "#E6E6E6", color: "#E6E6E6"}} />
    }
    return (
      <Menu.Item
        key={key}
        disabled={disabled}
        onClick={onClick}
        className={`custom-menu-item ${itemClassName} ${active && 'custom-menu-item-active'}`}
      >
        <div className="custom-menu-item-content" data-clstag={clstag}>
          {showIcon && icon && iconPosition === 'left' && (
            <span className="custom-menu-item-icon">{icon}</span>
          )}
          <span className="custom-menu-item-label">{label}</span>
          {showIcon && icon && iconPosition === 'right' && (
            <span className="custom-menu-item-icon">{icon}</span>
          )}
        </div>
      </Menu.Item>
    );
  };

  return (
    <Menu
      id='custom-menu'
      className={`${className}`}
      style={{
        ...styleObj
      }}
      {...restProps}
    >
      {items.map(renderMenuItem)}
    </Menu>
  );
};